import { render } from "./ProductTile.vue?vue&type=template&id=aa596ec0&scoped=true"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"

import "./ProductTile.vue?vue&type=style&index=0&id=aa596ec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa596ec0"]])

export default __exports__